"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var updateItemRequest_1 = require("owa-service/lib/factory/updateItemRequest");
var deleteItemField_1 = require("owa-service/lib/factory/deleteItemField");
var propertyUri_1 = require("owa-service/lib/factory/propertyUri");
var itemId_1 = require("owa-service/lib/factory/itemId");
var itemChange_1 = require("owa-service/lib/factory/itemChange");
// Import functions
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
var updateItemOperation_1 = require("owa-service/lib/operation/updateItemOperation");
var createSetItemField_1 = require("owa-mail-store/lib/services/utils/createSetItemField");
// Import utils
var pinningUtils_1 = require("owa-mail-list-store/lib/utils/pinningUtils");
function createRequestBody(itemIdsToUpdate, shouldMarkAsPinned) {
    var itemChanges = [];
    for (var _i = 0, itemIdsToUpdate_1 = itemIdsToUpdate; _i < itemIdsToUpdate_1.length; _i++) {
        var messageItemId = itemIdsToUpdate_1[_i];
        var update = void 0;
        var propertyName = 'RenewTime';
        if (shouldMarkAsPinned) {
            // Set renew time to pin time
            update = createSetItemField_1.default(propertyName, pinningUtils_1.utcPinnedEwsTimeStamp);
        }
        else {
            // Remove renew time property
            update = deleteItemField_1.default({
                Path: propertyUri_1.default({ FieldURI: propertyName }),
            });
        }
        var singleItemChange = itemChange_1.default({
            Updates: [update],
            ItemId: itemId_1.default({
                Id: messageItemId,
            }),
        });
        itemChanges.push(singleItemChange);
    }
    return updateItemRequest_1.default({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}
function markItemsAsPinnedService(itemIdsToUpdate, shouldMarkAsPinned) {
    var requestBody = createRequestBody(itemIdsToUpdate, shouldMarkAsPinned);
    // We want to always set the pin time in UTC time, so it's invariant to user time zone
    var jsonRequestHeader = ServiceRequestUtils_1.getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';
    return updateItemOperation_1.default({
        Header: jsonRequestHeader,
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = markItemsAsPinnedService;
//# sourceMappingURL=markItemsAsPinnedService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/markItemsAsPinnedService.js
// module id = 3822
// module chunks = 62